// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompassTwoToneSvg from "@fishx/icons-svg/es/asn/CompassTwoTone";
import FishxIcon from '../components/FishxIcon';

var CompassTwoTone = function CompassTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompassTwoToneSvg
  }));
};

CompassTwoTone.displayName = 'CompassTwoTone';
export default React.forwardRef(CompassTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CompassTwoTone.js
// module id = 2293
// module chunks = 0